import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/filter/box-open.svg'


const _withScopeId = n => (_pushScopeId("data-v-0792bbda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid row gap-5 p-0" }
const _hoisted_2 = { class: "col-12 d-flex justify-content-between align-items-center p-0" }
const _hoisted_3 = { class: "d-flex gap-3" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex flex-row justify-content-between rounded-2",
  style: {"height":"40.94px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content","font-size":"20px"},
  class: "m-0 fas fa-search"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content","font-size":"20px"},
  class: "m-0 fas fa-search"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content","font-size":"20px"},
  class: "m-0 fas fa-times"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content","font-size":"20px"},
  class: "m-0 fas fa-plus"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-upload text-red",
  style: {"font-size":"20px"}
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-download text-red",
  style: {"font-size":"20px"}
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content","font-size":"20px"},
  class: "m-0 fas fa-arrow-left"
}, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "card d-flex p-2 gap-5"
}
const _hoisted_13 = {
  key: 0,
  class: "col-12 d-flex flex-column p-0",
  style: {"font-size":"17px","overflow-x":"scroll"}
}
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<li style=\"border-radius:10px 10px 0px 0px;min-width:930px;border-bottom:0.5px solid #F3F3F3;\" class=\"col-12 p-5 d-flex flex-row\" data-v-0792bbda><span class=\"m-0 col-2 d-flex justify-content-center\" data-v-0792bbda>CÓDIGO</span><span class=\"m-0 col-5 d-flex justify-content-center\" data-v-0792bbda>PRODUTO</span><span class=\"m-0 col-2 d-flex justify-content-center\" data-v-0792bbda>GRUPO</span><span class=\"m-0 col-1 d-flex justify-content-center\" data-v-0792bbda>PREÇO</span><span class=\"m-0 col-1 d-flex justify-content-center\" data-v-0792bbda>ESTOQUE</span><span class=\"m-0 col-1 d-flex justify-content-center\" data-v-0792bbda>AÇÃO</span></li>", 1)
const _hoisted_15 = {
  key: 0,
  style: {"position":"absolute","color":"#D7D000","font-size":"20px"},
  class: "fas fa-exclamation-triangle",
  title: "Produto não homologado"
}
const _hoisted_16 = { class: "col-2 d-flex justify-content-center" }
const _hoisted_17 = ["title"]
const _hoisted_18 = ["title"]
const _hoisted_19 = { class: "col-1 d-flex justify-content-center" }
const _hoisted_20 = { class: "col-1 d-flex justify-content-center" }
const _hoisted_21 = { class: "col-1 d-flex gap-3 justify-content-center" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "18",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19.4492 5.55078L17.6484 7.35156C17.4648 7.53516 17.168 7.53516 16.9844 7.35156L12.6484 3.01562C12.4648 2.83203 12.4648 2.53516 12.6484 2.35156L14.4492 0.550781C15.1797 -0.179688 16.3672 -0.179688 17.1016 0.550781L19.4492 2.89844C20.1836 3.62891 20.1836 4.81641 19.4492 5.55078ZM11.1016 3.89844L0.84374 14.1562L0.0156149 18.9023C-0.0976663 19.543 0.460927 20.0977 1.10155 19.9883L5.84765 19.1562L16.1055 8.89844C16.2891 8.71484 16.2891 8.41797 16.1055 8.23438L11.7695 3.89844C11.582 3.71484 11.2851 3.71484 11.1016 3.89844ZM4.84765 13.2773C4.6328 13.0625 4.6328 12.7188 4.84765 12.5039L10.8633 6.48828C11.0781 6.27344 11.4219 6.27344 11.6367 6.48828C11.8516 6.70313 11.8516 7.04688 11.6367 7.26172L5.62108 13.2773C5.40624 13.4922 5.06249 13.4922 4.84765 13.2773ZM3.43749 16.5625H5.31249V17.9805L2.79296 18.4219L1.57811 17.207L2.01952 14.6875H3.43749V16.5625Z",
    fill: "white"
  })
], -1))
const _hoisted_23 = {
  key: 1,
  style: {"color":"#dc3545"},
  class: "spinner-border m-auto",
  role: "status"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 1,
  class: "card d-flex h-100 justify-content-center",
  id: "empty"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"color":"rgb(213 202 202)"} }, "Esta loja não possui produtos cadastrados", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "m-5",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_ModalTelaProduto = _resolveComponent("ModalTelaProduto")!
  const _component_ModalUploadProdutos = _resolveComponent("ModalUploadProdutos")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_Title, null, {
        default: _withCtx(() => [
          _createTextVNode("Produtos")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.openFind)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paramsProdutos.input) = $event)),
                style: {"border":"0.5px solid #F3F3F3 !important","border-right":"none !important","border-radius":"4px 0px 0px 4px !important"},
                type: "text",
                placeholder: "Procurar por um produto...",
                class: "border-0 w-100 ps-2"
              }, null, 512), [
                [_vModelText, _ctx.paramsProdutos.input]
              ]),
              _createVNode(_component_Button, {
                variant: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getProdutosLoja(), _ctx.page = 1)),
                style: {"border-radius":"0px 4px 4px 0px !important"}
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (!_ctx.openFind)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openFind = !_ctx.openFind))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.openFind)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 2,
              variant: "secondary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openFind = !_ctx.openFind))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_Button, {
          text: _ctx.isHomologado ? 'Não homologados' : 'Homologados',
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getNaoHomologados()))
        }, null, 8, ["text"]),
        _createVNode(_component_Button, {
          text: "Adição unitária",
          onClick: _ctx.buscarProduto
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, { onClick: _ctx.openInput }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, { onClick: _ctx.downloadProducts }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_router_link, {
          to: "/lojas",
          style: {"height":"fit-content","white-space":"nowrap"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, { text: "Voltar" }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.produtos.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (!_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                _hoisted_14,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produtos, (item, key) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: key,
                    class: "listaZebra col-12 d-flex flex-row align-items-center p-4",
                    style: {"color":"#464e5f","min-width":"930px","position":"relative"}
                  }, [
                    (!item.homologado)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_15))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(item.codProdutoLoja), 1),
                    _createElementVNode("span", {
                      class: "col-5 text-center d-block",
                      title: item.produto,
                      style: {"word-break":"break-all"}
                    }, _toDisplayString(item.produto), 9, _hoisted_17),
                    _createElementVNode("span", {
                      class: "col-2 text-center d-block px-4",
                      title: item.grupoExibicao
                    }, _toDisplayString(item.grupoExibicao), 9, _hoisted_18),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(item.preco !== null ? Number(item.preco.replace(',',
              '.')).toLocaleString("pt-BR", { style: "currency", currency: "BRL", }) : 'R$ 0,00'), 1),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(item.estoque), 1),
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_Button, {
                        variant: "secondary",
                        onClick: ($event: any) => (_ctx.buscarProduto(item))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_22
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_29)),
    (_openBlock(), _createBlock(_component_Pagination, {
      ref: "pagination",
      key: _ctx.route.path,
      arr: _ctx.produtos,
      totalBanco: _ctx.totalProdutos,
      onPageChanged: _ctx.handlePageChange,
      tipo: 'Produtos encontrados'
    }, null, 8, ["arr", "totalBanco", "onPageChanged"])),
    _createVNode(_component_ModalTelaProduto, {
      product: _ctx.produto,
      onAttProdutos: _ctx.getProdutosLoja,
      onCloseModal: _ctx.closeModal,
      idLoja: Number(_ctx.idLoja)
    }, null, 8, ["product", "onAttProdutos", "onCloseModal", "idLoja"]),
    _createVNode(_component_ModalUploadProdutos, {
      productsList: _ctx.productsToUpload,
      closeModal: _ctx.closeModal,
      getProdutosLoja: _ctx.getProdutosLoja
    }, null, 8, ["productsList", "closeModal", "getProdutosLoja"]),
    _createElementVNode("input", {
      type: "file",
      id: "file-input",
      ref: "fileInput",
      onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.uploadProducts && _ctx.uploadProducts(...args))),
      style: {"display":"none"},
      accept: ".xlsx"
    }, null, 544)
  ]))
}